import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M28.833 12.834c-.666-.667-1.666-.667-2.333 0L16.333 23.501l-3.166-3.334c-.667-.666-1.667-.666-2.334 0-.666.667-.666 1.834 0 2.5L15 27.001c.667.666 1.667.666 2.333 0L28.5 15.167c1-.5 1-1.666.333-2.333",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }